module.exports = __webpack_public_path__ + "img/details-list.aa83b7e1.svg";